let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("804k8")).then(() => parcelRequire('iAgQg'));